import { EmailTemplate } from "../interfaces/table";
import { createApi } from "@reduxjs/toolkit/query/react";
import { AddEmailTemplateBody } from "../interfaces/api";
import {
  parseReduxQueryError,
  customBaseQuery,
} from "../../common/reduxQuery/helpers";
import { fetchedEmailTemplates } from "./emailTemplatesSlice";

export const emailTemplatesApi = createApi({
  reducerPath: "emailTemplatesApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    fetchEmailTemplates: build.query<Array<EmailTemplate>, string>({
      query: (userId) => ({
        url: `/api/v1/user/${userId}/email-templates`,
        method: "GET",
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(fetchedEmailTemplates(data));
        } catch (err) {
          console.error(
            `An error occurred while retrieving the email templates: ${parseReduxQueryError(
              err,
            )}`,
          );
        }
      },
    }),
    removeEmailTemplate: build.mutation<void, string>({
      query: (id) => ({
        url: `/api/v1/email-templates/delete/${id}`,
        method: "DELETE",
      }),
    }),
    addEmailTemplate: build.mutation<EmailTemplate, AddEmailTemplateBody>({
      query: ({ emailTemplate, userId }) => ({
        url: `/api/v1/user/${userId}/email-template`,
        body: emailTemplate,
        method: "POST",
      }),
    }),
    updateEmailTemplate: build.mutation<void, EmailTemplate>({
      query: (emailTemplate) => ({
        url: `/api/v1/email-templates/update`,
        body: emailTemplate,
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useFetchEmailTemplatesQuery,
  useRemoveEmailTemplateMutation,
  useAddEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
} = emailTemplatesApi;
